// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperThumbnail-cls1_zET","cls2":"PaperThumbnail-cls2_vEI PaperThumbnail-cls1_zET"};